import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProgressUpdate {
  percentage: number;
  [key: string]: any;
}

interface FailureData {
  message: string;
  [key: string]: any;
}

interface PricingUploadState {
  percentage: number;
  message: string;
  updates: ProgressUpdate[];
  failure: boolean;
}

const initialState: PricingUploadState = {
  percentage: -1,
  message: '',
  updates: [],
  failure: false,
};

const gameSkuPricingUploadSlice = createSlice({
  name: 'gameskuPricingUpload',
  initialState,
  reducers: {
    processingGameSkuPricingUpload: (
      state,
      action: PayloadAction<ProgressUpdate>
    ) => {
      return {
        ...state,
        percentage: action.payload.percentage,
        updates: [...state.updates, action.payload],
      };
    },
    clearGameSkuPricingUpload: () => {
      return initialState;
    },
    uploadGameSkuPricingFailure: (
      state,
      action: PayloadAction<FailureData>
    ) => {
      return {
        ...state,
        failure: true,
        message: action.payload.message,
      };
    },
  },
});

export const {
  processingGameSkuPricingUpload,
  clearGameSkuPricingUpload,
  uploadGameSkuPricingFailure,
} = gameSkuPricingUploadSlice.actions;

export default gameSkuPricingUploadSlice.reducer;
